import { makeListReducer, SORT_ORDER } from 'lib/list-helper/makeListReducer';

export const { reducer, initialState } = makeListReducer(
  {},
  {
    sortBy: 'id',
    sortOrder: SORT_ORDER.DESC,
  },
);
